import { DSCommonData, LinkedLinkProps } from 'shared-definitions/types'
import { ApiResponseCommonData } from 'data-source/types.wp'
import { menuItemMapper } from 'data-source/mappers/menuItemMapper'
import { dealBarMapper } from 'data-source/mappers/dealBarMapper'
import { socialsMapper } from 'data-source/mappers/socialsMapper'
import { pLinkExternalMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

interface CodecGetCommonDataOpts extends PLinkMapperOpts {
  homeLink: LinkedLinkProps
  searchLink: LinkedLinkProps
  dealsLink: LinkedLinkProps
  productsLink: LinkedLinkProps
  profileLink: LinkedLinkProps
}

export function codecGetCommonData(
  raw: ApiResponseCommonData,
  opts: CodecGetCommonDataOpts
): DSCommonData {
  const input = raw.data
  return {
    menuMain: input.header.menu_side.map(item => {
      if ('items' in item) {
        return {
          title: item.title,
          items: item.items.map(menuItemMapper),
          listLink: item.list_link ?? null,
        }
      }
      return item
    }),
    strings: {
      searchPlaceholder: input.header.search_placeholder,
      copyrights: input.footer.copyrights,
      loadMore: input.loading.load_more_label,
      loading: input.loading.loading_label,
      msgCheck: input.forms.button.check,
      msgSubmit: input.forms.button.default,
      msgError: input.forms.button.error,
      msgSuccess: input.forms.button.success,
      errEmail: input.forms.errors.email,
      errGeneral: input.forms.errors.general,
      errRequired: input.forms.errors.required,
      disclaimer: input.disclaimer,
      next: input.next_label,
      previous: input.previous_label,
    },
    dealsButton: {
      label: input.header.button_label,
      pLink: opts.dealsLink,
    },
    advertiseButton: {
      label: input.footer.button_label,
      pLink: pLinkExternalMapper(input.footer.button_link),
    },
    menuFooter: input.footer.menu.map(({ url, title }) => ({
      url,
      title,
    })),
    socials: socialsMapper(input.footer.socials),
    dealBar: input.dealbar
      ? {
          id: input.dealbar.id,
          type: input.dealbar.placement_type,
          default: input.dealbar.default ? dealBarMapper(input.dealbar.default, opts) : null,
        }
      : null,
    profileLink: { href: opts.profileLink.href },
    homeLink: opts.homeLink,
    searchLink: opts.searchLink,
    productsLink: opts.productsLink,
    dealsLink: opts.dealsLink,
  }
}
